import React from 'react';

/** Ophthalmology module — VA, IOP, refraction */
export default function OphthalmologyPanel({ value = {}, onChange, readOnly }) {
  const set = (k, v) => onChange?.({ ...value, [k]: v });
  const eye = (side) => (
    <div className="card" style={{ padding: 12 }}>
      <h5 style={{ margin: '0 0 8px' }}>{side === 'od' ? 'Right eye (OD)' : 'Left eye (OS)'}</h5>
      <div className="form-grid">
        <div className="field"><label>Visual acuity</label><input className="input" placeholder="6/6" value={value[`va_${side}`] || ''} readOnly={readOnly} onChange={(e) => set(`va_${side}`, e.target.value)} /></div>
        <div className="field"><label>Sphere</label><input className="input" placeholder="-1.25" value={value[`sph_${side}`] || ''} readOnly={readOnly} onChange={(e) => set(`sph_${side}`, e.target.value)} /></div>
        <div className="field"><label>Cylinder</label><input className="input" value={value[`cyl_${side}`] || ''} readOnly={readOnly} onChange={(e) => set(`cyl_${side}`, e.target.value)} /></div>
        <div className="field"><label>Axis</label><input className="input" value={value[`axis_${side}`] || ''} readOnly={readOnly} onChange={(e) => set(`axis_${side}`, e.target.value)} /></div>
        <div className="field"><label>IOP mmHg</label><input className="input" value={value[`iop_${side}`] || ''} readOnly={readOnly} onChange={(e) => set(`iop_${side}`, e.target.value)} /></div>
      </div>
    </div>
  );

  return (
    <div style={{ marginTop: 12 }}>
      <h4 style={{ color: '#7c3aed', marginBottom: 8 }}>Ophthalmology examination</h4>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
        {eye('od')}
        {eye('os')}
      </div>
      <div className="field full" style={{ marginTop: 12 }}>
        <label>Fundus / slit-lamp findings</label>
        <textarea className="input" rows={2} value={value.fundus || ''} readOnly={readOnly} onChange={(e) => set('fundus', e.target.value)} />
      </div>
    </div>
  );
}
